var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporateSustainability176(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.33,84.84H73.62m41.83,0h38.28M70.46,57.21V43.8h48.15V57.21M104.85,90.8H84.21V79.54h20.64Zm.06,41.79H35.33v-75h118.4V96.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.36,167.13s73.52,42.07,73-69m-74.54,67.37s-36.92-76.23,73.91-68m-17,34.59-14.39-4.86m-13.9-16.58,5.64,21.8m5.81,24.13-21.36-7.13m-33.88,31,87.53-81.72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateSustainability176);
export default __webpack_public_path__ + "static/media/CORPORATE_SUSTAINABILITY_176.7d4160add8af350b7d8d72f3d8f5efee.svg";
export { ForwardRef as ReactComponent };